module.exports = __webpack_public_path__ + "static/media/pg_testing_a_bg_sm.ea505698.jpg";